import constants from '@/app-configs/constants'

export default [
  {
    path: '/currency-settings',
    name: 'currency-settings',
    component: () => import('@/views/settings/CurrencySettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_CURRENCY_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_CURRENCY_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
